import { ProblemDetails } from "../models/Http";
import { get, put, upload } from "./api";
import { err, ok, Result } from "../result";
import { LoginMethod, Market, OnBoarding, Support } from "../models/Market";
import { SegmentRule } from "../models/Segment";

export const list = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<Market>>
> => {
  const response = await get(`/v1/markets`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<Market>);
  }

  return err(content as ProblemDetails);
};

export const getCurrentMarket = async (): Promise<
  Result<ProblemDetails, Market>
> => {
  const response = await get(`/v1/markets/current`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as Market);
  }

  return err(content as ProblemDetails);
};

export const getLoginMethods = async (): Promise<
  Result<ProblemDetails, ReadonlyArray<LoginMethod>>
> => {
  const response = await get(`/v1/markets/login-methods`);
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<LoginMethod>);
  }

  return err(content as ProblemDetails);
};

export const upsert = async (
  market: Market
): Promise<Result<ProblemDetails, any>> => {
  const response = await put(`/v1/markets/`, market);

  if (!response.ok) {
    const content = await response.json();
    return err(content as ProblemDetails);
  }

  return ok({});
};

export const upsertSupport = async (
  id: number,
  support: Support
): Promise<Result<ProblemDetails, any>> => {
  const response = await put(`/v1/markets/${id}/support`, support);

  if (!response.ok) {
    const content = await response.json();
    return err(content as ProblemDetails);
  }

  return ok({});
};

export const upsertOnBoardings = async (
  id: number,
  onBoardings: ReadonlyArray<OnBoarding>
): Promise<Result<ProblemDetails, any>> => {
  const response = await put(`/v1/markets/${id}/onboarding`, onBoardings);

  if (!response.ok) {
    const content = await response.json();
    return err(content as ProblemDetails);
  }

  return ok({});
};

export const uploadImage = async (
  id: number,
  image: Blob
): Promise<Result<ProblemDetails, OnBoarding>> => {
  const response = await upload(`/v1/markets/${id}/onboarding-image`, image);
  const content = await response.json();

  if (response.ok) {
    return ok(content as OnBoarding);
  }

  return err(content as ProblemDetails);
};
